import React, { Component } from "react";
import { renderRoutes } from "react-router-config";
import { Header, Footer } from "../components";
import { withRedux } from "../hoc";
import { initApp } from "../actions";
import { getAuthByTokenAction } from "../actions/auth";
import "../assets/css/index.scss";

const mapStateToProps = state => {
  return state;
};

const actions = {
  initApp,
  getAuthByTokenAction
};

@withRedux(mapStateToProps, actions)
export default class Root extends Component {
  componentWillMount() {
    this.props.actions.initApp();
    const token = window.localStorage.getItem("token");
    if (token) {
      this.props.actions.getAuthByTokenAction(token);
    }
  }
  render() {
    const { route } = this.props;
    return (
      <div className="layout">
        <Header />
        <div className="main-content">{renderRoutes(route.routes)}</div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Root.js